module.exports = __webpack_public_path__ + "img/1707294214514.aaf97c63.jpg";